import { useEffect, useRef } from 'react'
import { useLocation } from 'react-router'

interface UseCloseInvoicingSettingsOnLeaveProps {
  closeSettingsModal: () => void
  closeUnsavedChangesModal: () => void
  resetPendingNavigation: () => void
}

export const useCloseInvoicingSettingsOnLeave = ({
  closeSettingsModal,
  closeUnsavedChangesModal,
  resetPendingNavigation,
}: UseCloseInvoicingSettingsOnLeaveProps) => {
  const { pathname } = useLocation()
  const lastPathnameRef = useRef(pathname)

  // The user has already left the page, so the dirty and saving guards of `requestNavigation` don't apply.
  // Only the pathname counts; search and hash changes stay on the same page.
  useEffect(() => {
    if (pathname === lastPathnameRef.current) {
      return
    }

    lastPathnameRef.current = pathname
    resetPendingNavigation()
    closeUnsavedChangesModal()
    closeSettingsModal()
  }, [closeSettingsModal, closeUnsavedChangesModal, pathname, resetPendingNavigation])

  // The modal's open state outlives the host, so close it when the host unmounts with its route.
  useEffect(
    () => () => {
      closeUnsavedChangesModal()
      closeSettingsModal()
    },
    [closeSettingsModal, closeUnsavedChangesModal],
  )
}
